<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-18 15:44:08
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/list/components/OrderHeader/index.vue
-->
<template>
  <div class="order_header">
    <div class="header_left">
      <img src="@/assets/order/icon_order1@2x.png" alt="" class="left_icon" />
      <div class="colo087 font14 font_weight500 line_height_20 header_title">
        {{ headerTitle }}
      </div>
    </div>
    <div class="header_right">
      <div
        :class="{
          status_red_color: isRedStatus
        }"
        class="colo038 font12 font_weight400 line_height_20 header_status"
        @click="clickBtn"
      >
        {{ statusText }}
      </div>
      <img
        v-if="!isRedStatus && storeDet.status !== 13 && storeDet.status !== 14"
        src="@/assets/mine/icon_delete@2x.png"
        alt=""
        class="right_delete"
        @click="clickBtn"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    storeDet: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    isRedStatus() {
      const status = this.storeDet.status;
      if (status === 13 || status === 14) return false;
      // 小于 0 且不是审核失败、退款中，说明是订单关闭
      if (status < 0 && status !== -5 && status !== -9) return false;
      return true;
    },
    headerTitle() {
      if (this.storeDet.kind === 4) {
        return `${this.storeDet.activityName || ""}订单`;
      }
      if (this.storeDet.kind === 5) {
        return `${this.storeDet.activityName || ""}抽奖订单`;
      }
      return this.storeDet.storeName || "";
    },
    statusText() {
      const { kind, groupStatus, status, deliveryMode } = this.storeDet;
      if (kind === 7) {
        if (groupStatus === 20) {
          return "待成团";
        }
        if (groupStatus === 25) {
          return "待提货";
        }
      }
      // 非代客下单且处于待付款状态
      if (kind !== 10 && status === 10) {
        return "待客户付款";
      }
      // 自提且处于待发货状态 (status === 11)
      if (deliveryMode === 0 && status === 11) {
        return "待提货";
      }
      if (status === 5) return "待审核";
      if (status === -5) return "审核失败";
      if (status === -9) return "退款中";
      if (status < 0 && status !== -5 && status !== -9) return "订单关闭";

      switch (status) {
        case 10:
          return "待付款";
        case 11:
          return "待发货";
        case 12:
          return "待收货";
        case 13:
        case 14:
          return "已完成";
        default:
          return "";
      }
    }
  },
  methods: {
    clickBtn() {
      this.$emit("clickBtn", "删除订单", this.storeDet.orderSn);
    }
  }
};
</script>
<style lang="less" scoped>
.order_header {
  padding: 11px 0 9px;
  margin: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header_left {
    display: flex;
    align-items: center;
  }

  .header_right {
    display: flex;
    align-items: center;
  }

  .left_icon {
    width: 20px;
  }
  .header_title {
    margin-left: 8px;
  }
  .header_status {
    // 垂直居中，不再需要额外的 padding-top
  }
  .right_delete {
    width: 16px;
    margin-left: 8px;
  }
  // 红色的状态字体
  .status_red_color {
    color: #d91818;
  }
}
</style>
